export var GUEST_CATEGORY_STAYS_FIELD = 'smartData.stays.finishedStays';
export var GUEST_CATEGORY_NIGHTS_FIELD = 'smartData.stays.finishedNights';
